"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinPullupParametricSchema = exports.PinPullupParametric = void 0;
const zod_1 = require("zod");
var PinPullupParametric;
(function (PinPullupParametric) {
    PinPullupParametric["Pullup"] = "pullup";
    PinPullupParametric["Pulldown"] = "pulldown";
    PinPullupParametric["PullUpDown"] = "pullupdown";
})(PinPullupParametric || (exports.PinPullupParametric = PinPullupParametric = {}));
exports.PinPullupParametricSchema = zod_1.z.nativeEnum(PinPullupParametric);
//# sourceMappingURL=PinPullupParametric.js.map